// extracted by mini-css-extract-plugin
export var donut = "index-module--donut--DZfzp";
export var footer = "index-module--footer--uojx8";
export var about = "index-module--about--Shv9m";
export var image = "index-module--image--g0yZg";
export var text = "index-module--text--mR-Ho";
export var headline = "index-module--headline--Ky6Zc";
export var legal = "index-module--legal--OACvX";
export var link = "index-module--link--Uhx06";
export var fadein = "index-module--fadein--NNweW";